// FILE: frontend/src/components/ConversationView.jsx
// Active conversation layout: goals bar + transcript + score cards + PTT
// Assembled from sub-components, receives all data as props

import React from 'react'
import GoalsBar from './GoalsBar'
import TranscriptPanel from './TranscriptPanel'
import PTTButton from './PTTButton'
import TestPanel from './TestPanel'

export default function ConversationView({
  // Lesson info
  lessonTitle,
  // Conversation data
  timeline,
  assistantText,
  transcript,
  scores,
  goals,
  goalKeys,
  // UI config from backend
  uiConfig,
  // PTT state
  micActive,
  isRecording,
  onTogglePTT,
  // Test mode
  mode,
  placedLevel,
  testScores,
  // Error
  error,
}) {
  const showGoals = uiConfig?.show_goals !== false && mode === 'practice'
  const showScores = uiConfig?.show_per_turn_feedback !== false

  return (
    <div className="sqa-chat-area">
      {/* Lesson header */}
      <div className="sqa-lesson-header">
        <div className="sqa-lesson-info">
          <div className="sqa-lesson-icon">📚</div>
          <div className="sqa-lesson-title">
            {mode === 'test' ? 'Placement Test' : lessonTitle || 'Lesson'}
          </div>
        </div>
      </div>

      {/* Goals bar (practice mode, lower levels) */}
      {mode === 'practice' && (
        <GoalsBar goals={goals} goalKeys={goalKeys} visible={showGoals} />
      )}

      {/* Error banner */}
      {error && (
        <div className="sqa-error" style={{ margin: '12px 22px' }}>
          {error}
        </div>
      )}

      {/* Main content area */}
      {mode === 'test' ? (
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          <div style={{ flex: 1 }}>
            <TranscriptPanel
              timeline={timeline}
              assistantText={assistantText}
              transcript={transcript}
              scores={scores}
              showScores={false}
            />
          </div>
          <div style={{ width: 280, padding: 16, overflowY: 'auto', borderLeft: '1px solid var(--gray-200)' }}>
            <TestPanel placedLevel={placedLevel} testScores={testScores} />
          </div>
        </div>
      ) : (
        <TranscriptPanel
          timeline={timeline}
          assistantText={assistantText}
          transcript={transcript}
          scores={scores}
          showScores={showScores}
        />
      )}

      {/* PTT / Recording indicator */}
      <PTTButton
        uiConfig={uiConfig}
        micActive={micActive}
        isRecording={isRecording}
        onTogglePTT={onTogglePTT}
      />
    </div>
  )
}
